import { Component, h, Method, Prop, State } from '@stencil/core';

@Component({
	tag: 'kdx-faq',
	styleUrl: 'faq-item.scss',
	shadow: false,
})
export class FaqItem {

	@Prop() faqTitle: string;
	@Prop({mutable: true}) faqId: string;
	@State() open: boolean = false;

	componentWillLoad() {
		// If not id is provided, generate one using the faq title.
		if (!this.faqId) {
			this.faqId = this.faqTitle.replace(/[^A-Z0-9]/ig, "-");
		}

		// If hash matches this faq, start it open.
		if (window.location.hash && window.location.hash.toLowerCase() == '#' + this.faqId.toLowerCase()) {
			this.open = true;
		}
	}

	toggleFaq(e) {
		this.closeOtherFaqs();
		this.open = !this.open;
		e.currentTarget.setAttribute("aria-expanded", "true");
	}

	hoveredIn(e) {
		e.target.closest('.kdx-faq').classList.add('hover');
	}
	
	hoveredOut(e) {
		e.target.closest('.kdx-faq').classList.remove('hover');
	}

	closeOtherFaqs() {
		const faqs = document.querySelectorAll('kdx-faq');

		faqs.forEach((faq) => {
			if (faq.faqId != this.faqId) {
				faq.closeFaq();
				faq.setAttribute("aria-expanded", "false");
			}
		});
	}

	@Method() async closeFaq() {
		this.open = false;		
	}

	render() {
		return (
			<div class={`kdx-faq ${this.open ? 'open' : ''}`}>
				<h3>
					<button
						type="button"
						id={`accordion-trigger-${this.faqId}`}
						class={`kdx-faq-title accordion-trigger`}
						aria-expanded={this.open ? "true" : "false"}
						aria-controls={`accordion-panel-${this.faqId}`}
						onClick={(e) => {this.toggleFaq(e)}}
						onKeyPress={(e) => e.key === 'Enter' ? this.toggleFaq(e) : null}
						onMouseEnter={this.hoveredIn}
						onMouseLeave={this.hoveredOut}
						onFocusin={this.hoveredIn}
						onFocusout={this.hoveredOut}
					>
						<span class="icon">
							<kdx-icon icon="chevron-right" /> 
						</span>

						{ this.faqTitle }
					</button>
				</h3>

				<div 
					id={`accordion-panel-${this.faqId}`} 
					class="kdx-faq-content accordion-panel" 
					role="region"
					aria-labelledby={`accordion-trigger-${this.faqId}`}
				>
					<div class="kdx-faq-content-inner">
						<slot />
					</div>
				</div>
			</div>
		);
	}

}
